import React, { useEffect, useState } from 'react';
import { NotificationManager } from 'react-notifications';
import { Link as RouterLink } from 'react-router-dom';
import { Stack, Typography, Button, Card, Grid, TextField } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { formatDate } from '../../../../@core/utils/utilsFunctions';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import DataGrid, {
  Scrolling,
  Paging,
  HeaderFilter,
  Pager,
  SearchPanel,
  GroupPanel,
  Column,
  ColumnChooser,
  ColumnFixing
} from 'devextreme-react/data-grid';

import configAxios from '../../../../services/configAxios';
import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';
import MoreMenu from '../../../components/multiplesComponents/MoreMenu';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';

const allowedPageSizes = [5, 10, 20, 30];

const Quotation = (props) => {
  const [infosQuotations, setInfosQuotations] = useState([]);
  const [infosFilter, setInfosFilter] = useState([]);

  useEffect(() => {
    getQuotations();
  }, []);

  function getQuotations() {
    // Operadora sempre vê todas as cotações
    const router = `/quotations/listQuotations/?dateinitial=${infosFilter.dateinitial}&dateend=${infosFilter.dateend}`;

    configAxios
      .get(router)
      .then((response) => {
        setInfosQuotations(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as cotações, por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  function HandleInputsFilters(event) {
    setInfosFilter({ ...infosFilter, [event.target.name]: event.target.value });
  }

  function ValidNome(data) {
    if (data.data) {
      return data.data;
    } else {
      return '-';
    }
  }

  function ActionsButtons(items) {
    const infos = [];
    infos.push(items.data.data);
    return infos.map((item) => (
      <MoreMenu
        key={item.id}
        infos={{
          id: item.id,
          router: 'editQuotation',
          functionGrid: getQuotations,
          otherInfos: item,
          deleteRouter: 'quotations/deleteQuotation',
          deleteItem: 'cotação'
        }}
      />
    ));
  }

  return (
    <RenderPage title="Cotação">
      <>
        <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
          <Grid container>
            <BreadcrumbsNav {...props} />
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Typography variant="h4" gutterBottom>
                Lista de cotações
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Utilize as opções abaixo para visualizar as informações das cotações
              </Typography>
            </Grid>
          </Grid>
          <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
            <Button
              variant="contained"
              component={RouterLink}
              to="/app/addQuotation"
              startIcon={<Iconify icon="eva:plus-fill" />}>
              Nova
            </Button>
            {!isMobile && (
              <Button
                variant="outlined"
                onClick={getQuotations}
                sx={{ ml: 1 }}
                startIcon={<Iconify icon="eva:refresh-outline" />}>
                Atualizar
              </Button>
            )}
          </Stack>
        </Stack>
        <Card>
          <CustomGrid>
            <CustomInfosForm>
              * Sem filtros, a busca é limitada aos últimos 200 registros
            </CustomInfosForm>
            <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
              <Grid item xs={12} md={3}>
                <TextField
                  name="dateinitial"
                  fullWidth
                  label="Data inicial"
                  variant="outlined"
                  size="small"
                  type="date"
                  // required
                  value={infosFilter.dateinitial || ''}
                  onChange={(event) => HandleInputsFilters(event)}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  name="dateend"
                  fullWidth
                  label="Data final"
                  variant="outlined"
                  size="small"
                  type="date"
                  // required
                  value={infosFilter.dateend || ''}
                  onChange={(event) => HandleInputsFilters(event)}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              {!isMobile && (
                <Grid item xs={12} md={2}>
                  <Button
                    variant="contained"
                    size="medium"
                    color="primary"
                    onClick={() => getQuotations()}
                    startIcon={<Iconify icon="eva:funnel-outline" />}
                    sx={{ mr: 2 }}>
                    Filtrar
                  </Button>
                </Grid>
              )}
              {isMobile && (
                <Grid item xs={12} md={2}>
                  <Stack direction="row" alignItems="center" justifyContent="end" sx={{ mb: 1 }}>
                    <Button
                      variant="contained"
                      size="medium"
                      color="primary"
                      onClick={() => getQuotations()}
                      startIcon={<Iconify icon="eva:funnel-outline" />}
                      sx={{ mr: 2 }}>
                      Filtrar
                    </Button>
                  </Stack>
                </Grid>
              )}
            </Grid>
            <DataGrid
              dataSource={infosQuotations}
              showBorders={true}
              remoteOperations={true}
              wordWrapEnabled={true}
              allowColumnResizing={true}
              columnAutoWidth={true}
              noDataText={'Não há cotações cadastradas'}>
              <Column dataField="id" alignment="left" />
              <Column dataField="codquotation" caption="Cód. Cotação" alignment="left" />
              <Column
                dataField="upper_nome"
                caption="Nome/Razão social"
                alignment="left"
                width={200}
                cellRender={(data) => <ValidNome data={data.data.upper_nome} />}
              />
              <Column dataField="labelplans" caption="Plano" alignment="left" />
              <Column dataField="labeltables" caption="Tabela" alignment="left" />
              <Column dataField="tpcontrat_client" caption="Tipo de Contratação" alignment="left" />
              {/* <Column dataField="labelbroker" caption="Corretora" alignment="left" /> */}
              <Column
                dataField="valor_total"
                caption="Mensalidade Final"
                alignment="left"
                customizeText={(cellInfo) => {
                  const value = cellInfo.value;
                  if (!value && value !== 0) return '-';
                  const val =
                    typeof value === 'string' ? parseFloat(value.replace(',', '.')) : Number(value);
                  if (isNaN(val)) return '-';
                  return new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  }).format(val);
                }}
              />
              <Column
                dataField="datacadastro"
                caption="Dt. Cadastro"
                alignment="left"
                customizeText={(cellInfo) => {
                  const date = cellInfo.value;
                  if (!date) return '-';
                  let dateString = date;
                  if (date instanceof Date) {
                    dateString = date.toISOString().split('T')[0];
                  } else if (typeof date !== 'string') {
                    dateString = String(date);
                  }
                  if (typeof dateString === 'string' && dateString.includes('-')) {
                    try {
                      return formatDate(dateString);
                    } catch (e) {
                      return '-';
                    }
                  }
                  return '-';
                }}
              />
              <Column
                dataField="Ações"
                width={100}
                allowSorting={false}
                cellRender={(data) => <ActionsButtons data={data} />}
              />
              <SearchPanel visible={true} width={240} placeholder="Procurar..." />
              {!isMobile && (
                <GroupPanel visible={true} emptyPanelText="Arraste as colunas aqui para agrupar" />
              )}
              <Scrolling rowRenderingMode="virtual"></Scrolling>
              <Paging defaultPageSize={10} />
              <Pager
                visible={true}
                allowedPageSizes={allowedPageSizes}
                showPageSizeSelector={true}
                showInfo={true}
                showNavigationButtons={true}
              />
              <ColumnChooser
                enabled={true}
                title={'Escolher uma coluna'}
                emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
              />
              <ColumnFixing enabled={true} />
              <HeaderFilter visible={true} allowSearch={true} />
            </DataGrid>
          </CustomGrid>
        </Card>
      </>
    </RenderPage>
  );
};

export default Quotation;
